import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Grid,
  Select,
  FormErrorMessage,
  Stack,
  Box,
  Heading,
  Text,
  Image,
  Center,
  Flex,
  useToast,
} from "@chakra-ui/react";
import Multiselect from "multiselect-react-dropdown";
import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";
import { Form, Formik } from "formik";
import CustomInput from "components/common/customInput/CustomInput";
import {
  RegisterValidation,
  changePasswordValidation,
} from "components/Auth/validations/validation";
import HeadingSS from "App/BsesPoc/components/common/Heading/HeadingSS";
import ShadowBox from "components/common/ShadowBox/ShadowBox";
import { useLocation, useNavigate } from "react-router-dom";
// import CustomInput from "components/common/customInput/CustomInput";

type CreateFormValues = {
  id?: string;
  name: string;
  gstNumber: string;
  companyName: string;
  email: string;
  password?: string;
  confirmPassword?: string;
};

type CreateFormErrors = {
  email?: string;
  password?: string;
  confirmPassword?: string;
};

type ModalProps = {
  type: string;
  data?: CreateFormValues;
};

type RoleValues = {
  name: string;
  permissions: string[];
};

export default function CreateOrganisation({
  type,
  data,
}: ModalProps): JSX.Element {
  const { toastNotify } = useContext(AppContext);
  const navigate = useNavigate();
  const [showError, setShowError] = useState(false);
  const toast = useToast();

  const [values, setValues] = useState<CreateFormValues>({
    name: data?.name || "",
    gstNumber: data?.gstNumber || "",
    email: data?.email || "",
    password: data?.password || "",
    confirmPassword: data?.confirmPassword || "",
    companyName: data?.companyName || "",
  });
  const [errors, setErrors] = useState<CreateFormErrors>({});

  const [roles, setRoles] = useState<RoleValues[]>([]);

  const handleGetUserRoles = async () => {
    try {
      const response: any = await appRequest("userrole", "get", {});
      if (response) {
        if (Array.isArray(response)) {
          setRoles(response);
          // console.log("roles",response);
        } else {
          setRoles([]);
        }
      } else {
        toast({
          title: `Error getting the userroles`,
          description: response.message || "Something went wrong.",
          status: "error",
          duration: 9000,
          isClosable: true,
          position: "top-right",
        });

        toastNotify({
          title: `Error getting the userroles`,
          message: response.message || "Something went wrong.",
          type: "error",
        });
      }
    } catch (error: any) {
      toastNotify({
        title: `Error getting the roles.`,
        message: error.message || "Something went wrong.",
        type: "error",
      });
    }
  };

  useEffect(() => {
    handleGetUserRoles();
  }, []);

  const handleSubmit = async (event: React.FormEvent<HTMLButtonElement>) => {
    event.preventDefault();
    // Submit form
    const input = {
      id: data?.id,
      name: values.name,
      gstNumber: values.gstNumber,
      email: values.email,
      password: values.password,
      confirmPassword: values.confirmPassword,
    };

    try {
      const response: any = await appRequest(
        "user",
        type === "Add" ? "create" : "update",
        input
      );
      console.log("the response is", response);
      if (response) {
        if (response.status === "success") {
          let msg = type === "Add" ? "Added" : "Updated";
          let desc =
            type === "Add"
              ? "We've created a new user."
              : "We've updated the user.";
          toast({
            title: `User ${msg} successfully.`,
            description: desc || "Success",
            status: "success",
          });
          navigate("/login");
          // handleGetUser();
        } else {
          toast({
            title: "Account not created.",
            description: response.message || "Something went wrong.",
            status: "error",
          });
        }
      } else {
        toast({
          title: "Account not created.",
          description: response.message || "Something went Wrong.",
          status: "error",
        });
      }
    } catch (error: any) {
      console.log(error);
      toast({
        title: `Error Creating the user.`,
        description: error.message || "Something went wrong.",
        status: "error",
      });
    }
  };

  const handleSelected = (selectedList: any, selectedItem: any) => {
    selectedList = selectedList.map((item: any) => item.key);
    setValues((prevValues) => ({ ...prevValues, permission: selectedList }));
  };

  // For initial values
  const initialValues = {
    name: "",
    companyName: "",
    gstNumber: "",
    email: "",
    password: "",
    confirmPassword: "",
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (valuess: any, { setSubmitting, resetForm }) => {
        try {
          console.log(values, "Values in try");

          valuess = { ...values, ...valuess };

          console.log(valuess);

          delete valuess["confirmPassword"];

          const response: any = await appRequest("auth", "signUp", valuess);
          if (response) {
            if (response.status === "success") {
              let msg = type === "Add" ? "Added" : "Updated";
              let desc =
                type === "Add"
                  ? "We've created a new user."
                  : "We've updated the user.";
              toast({
                title: `User ${msg} successfully.`,
                description: desc || "Success",
                status: "success",
              });
              navigate("/login");
            } else {
              toast({
                title: "Account not created.",
                description: response.message || "Something went wrong.",
                status: "error",
              });
            }
          } else {
            toast({
              title: "Account not created.",
              description: response.message || "Something went wrong.",
              status: "error",
            });
          }
        } catch (error: any) {
          toast({
            title: "Account not created.",
            description: error.message || "Something went wrong.",
            status: "error",
          });
        } finally {
          setSubmitting(false);
        }
      }}
      validationSchema={RegisterValidation}
    >
      {({ handleSubmit, handleChange, values, errors, isSubmitting }: any) => {
        return (
          <Form onSubmit={handleSubmit}>
            {/* <HeadingSS headingSS="Create Organisation" /> */}
            <Box mx="auto" minH="100vh" w="7xl" p={6}>
              <ShadowBox p="1.5rem">
                <Grid gridTemplateColumns={{ lg: "1fr auto" }} gap={4}>
                  <Box order={{ base: 1, lg: 0 }}>
                    <Heading
                      color="teal.300"
                      fontSize={{ base: "2xl", md: "4xl" }}
                      fontWeight="700"
                      mb=".8rem"
                    >
                      Welcome!
                    </Heading>
                  </Box>

                  <Box>
                    <Image src="/img/sequelstring.webp" width={320} />
                  </Box>
                </Grid>

                <Grid
                  mt={type === "Edit" ? "0.5rem" : undefined}
                  templateColumns={{ lg: "1fr 1fr" }}
                  gridColumnGap={5}
                  gridRowGap={{ base: 2, lg: "8px" }}
                >
                  <CustomInput
                    label="Company Name"
                    type="text"
                    placeholder="Enter Company name"
                    name="companyName"
                    onChange={handleChange}
                    value={values.companyName}
                    error={errors.companyName}
                    showError={showError}
                  />
                  <CustomInput
                    label="GST Number"
                    type="text"
                    placeholder="Enter GST Number"
                    name="gstNumber"
                    onChange={handleChange}
                    value={values.gstNumber}
                    error={errors.gstNumber}
                    showError={showError}
                  />
                  <CustomInput
                    label="User Name"
                    type="text"
                    placeholder="Enter User Name"
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    error={errors.name}
                    showError={showError}
                  />
                  <CustomInput
                    label="Email"
                    type="text"
                    placeholder="Enter Email"
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    error={errors.email}
                    showError={showError}
                  />
                  {type === "Add" && (
                    <>
                      <CustomInput
                        label="New Password"
                        type="password"
                        placeholder="Your new password"
                        name="password"
                        value={values.password}
                        onChange={handleChange}
                        isRequired
                        error={errors.password}
                        showError={showError}
                      />
                      <CustomInput
                        label="Confirm Password"
                        type="password"
                        placeholder="Re-enter your new password"
                        name="confirmPassword"
                        value={values.confirmPassword}
                        onChange={handleChange}
                        isRequired
                        error={errors.confirmPassword}
                        showError={showError}
                      />
                    </>
                  )}
                </Grid>
                <Center>
                  <Flex gap={4} mt={4}>
                    <Button colorScheme="red" w="80px">
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      bg="teal.300"
                      // h={"45px"}
                      // fontWeight="700"
                      color="white"
                      _hover={{
                        bg: "teal.400",
                      }}
                      onClick={() => setShowError(true)}
                      isLoading={isSubmitting}
                    >
                      Save
                    </Button>
                  </Flex>
                </Center>
              </ShadowBox>
            </Box>
          </Form>
        );
      }}
    </Formik>
  );
}